import { supabase } from '@/lib/supabaseClient';

export const ROUTE_IMAGES_BUCKET = 'route-images';

export function safeStorageFilename(original) {
  const base = (original || 'image.jpg').split(/[/\\]/).pop() || 'image.jpg';
  return base.replace(/[^a-zA-Z0-9._-]/g, '_').slice(0, 80) || 'image.jpg';
}

export function buildRouteImageStoragePath(slug, filename) {
  return `${slug}/${Date.now()}-${safeStorageFilename(filename)}`;
}

export function storagePathFromRouteImageUrl(url) {
  if (!url || typeof url !== 'string') return null;
  const markers = [
    `/storage/v1/object/public/${ROUTE_IMAGES_BUCKET}/`,
    `/object/public/${ROUTE_IMAGES_BUCKET}/`,
  ];
  for (const marker of markers) {
    const idx = url.indexOf(marker);
    if (idx !== -1) {
      return decodeURIComponent(url.slice(idx + marker.length).split('?')[0]);
    }
  }
  return null;
}

/** Resolve static /images/routes/... paths or Supabase public URLs for display. */
export function resolveRouteImageUrl(imageUrl, slug) {
  const publicUrl = process.env.PUBLIC_URL || '';
  if (imageUrl) {
    if (/^https?:\/\//i.test(imageUrl)) return imageUrl;
    return `${publicUrl}${imageUrl.startsWith('/') ? imageUrl : `/${imageUrl}`}`;
  }
  return `${publicUrl}/images/routes/${slug}.jpg`;
}

export async function uploadRouteImage(slug, file) {
  const path = buildRouteImageStoragePath(slug, file.name);
  const { error: uploadError } = await supabase.storage
    .from(ROUTE_IMAGES_BUCKET)
    .upload(path, file, {
      contentType: file.type,
      upsert: false,
    });
  if (uploadError) throw uploadError;

  const { data: urlData } = supabase.storage.from(ROUTE_IMAGES_BUCKET).getPublicUrl(path);
  return urlData.publicUrl;
}

export async function deleteRouteImageFromUrl(imageUrl) {
  const storagePath = storagePathFromRouteImageUrl(imageUrl);
  if (!storagePath) return;
  const { error } = await supabase.storage.from(ROUTE_IMAGES_BUCKET).remove([storagePath]);
  if (error) throw error;
}
